import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ChantUserTextField, ChantUserModel } from '@core/models/cu/chant-user-model';
import { ImportALlModule } from '@shared/imports';
import { LANGUES_DATA } from '@shared/mock-data/langue.md';

@Component({
  selector: 'app-langue-dropdown',
  standalone: true,
  imports: [
      ImportALlModule,
  ],
  templateUrl: './langue-dropdown.component.html',
  styleUrl: './langue-dropdown.component.scss'
})
export class LangueDropdownComponent {

  textField = ChantUserTextField;
  @Input() objChant: ChantUserModel = new ChantUserModel();
  @Input() control!: FormControl;

  public typeChantList = LANGUES_DATA;//keyValueTypeChantList

  constructor(){  }
}
